module.exports = __webpack_public_path__ + "media/images/fieldmap-a0028b5a1ab228424ee792cea63b6007.jpg";